import { TermsResource, termsResource } from '@witkac/kartamiejska-resources';
import { Terms } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł regulaminów
 *
 * @export
 * @class TermsModule
 * @extends {EntityModule<Terms, TermsResource>}
 */
export class TermsModule extends EntityModule<Terms, TermsResource> {
  constructor() {
    super(termsResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje regulamin
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any) => {
        data.terms.id = await this.resource.add(data);
        context.commit('add', data.terms);
        context.commit('incrementCount');
      },
      /**
       * Aktualizuje regulamin
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: any) => {
        data.terms.id = await this.resource.update(data.id, data);
        context.commit('update', data.terms);
        context.commit('setEntity', data.terms);
      },
      /**
       * Pobieram aktualnie wymagane regulaminy
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      termsCurrent: async (context: any, data: any) => {
        const list = await this.resource.termsCurrent(data.profileType, data.required);
        context.commit('saveList', list);
        context.commit('saveCount', list.length);
      }
    };
  }
}

export default new TermsModule();
